var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeeInfoArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 7,
    viewBox: "0 0 14 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00053 5.37694L12.0223 0.35514C12.1548 0.222662 12.3108 0.158134 12.4903 0.161557C12.6698 0.164979 12.8257 0.23293 12.9582 0.365407C13.0907 0.497874 13.1569 0.653851 13.1569 0.83334C13.1569 1.01283 13.0907 1.16881 12.9582 1.30127L7.85436 6.41537C7.73385 6.5359 7.59881 6.62521 7.44925 6.68332C7.29967 6.74145 7.1501 6.77051 7.00053 6.77051C6.85096 6.77051 6.70139 6.74145 6.55181 6.68332C6.40225 6.62521 6.26721 6.5359 6.1467 6.41537L1.0326 1.30127C0.900118 1.16881 0.835584 1.01112 0.838995 0.828207C0.842418 0.645308 0.910368 0.487618 1.04285 0.355141C1.17532 0.222663 1.3313 0.156424 1.51078 0.156424C1.69027 0.156424 1.84625 0.222663 1.97873 0.355141L7.00053 5.37694Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeInfoArrow);
export default __webpack_public_path__ + "static/media/see-info-arrow.00dde4523f17a588105d4b5d376c71da.svg";
export { ForwardRef as ReactComponent };